// date lib
import parseISO from 'date-fns/parseISO';
import formatDate from 'date-fns/format';

const formatISODate = ({date, dateFormat = 'MM dd yyyy'}) =>
  formatDate(parseISO(date), dateFormat);

export default formatISODate;
